import {
  canAccessPortalArea,
  type AuthorizationSubject,
  type PortalCapabilityArea,
  type PortalCapabilityAction,
} from "@whitehaven/permissions";

function canAccessSchedulingAction(
  subject: AuthorizationSubject,
  action: PortalCapabilityAction,
  area?: PortalCapabilityArea,
): boolean {
  if (area) return canAccessPortalArea(subject, area, action);
  return (
    canAccessPortalArea(subject, "staff-schedule", action) ||
    canAccessPortalArea(subject, "admin-calendar", action) ||
    canAccessPortalArea(subject, "admin-scheduler", action) ||
    canAccessPortalArea(subject, "admin-appointments", action)
  );
}

export function canReadAdminScheduling(
  subject: AuthorizationSubject | null,
  area?: PortalCapabilityArea,
): boolean {
  return subject !== null && canAccessSchedulingAction(subject, "view", area);
}

export function canWriteAdminScheduling(
  subject: AuthorizationSubject | null,
  area?: PortalCapabilityArea,
): boolean {
  return (
    subject !== null && canAccessSchedulingAction(subject, "write", area)
  );
}

export function canOverrideAdminScheduling(
  subject: AuthorizationSubject | null,
  area?: PortalCapabilityArea,
): boolean {
  return (
    subject !== null && canAccessSchedulingAction(subject, "manage", area)
  );
}

export function adminSchedulingAuthorizationKey(
  subject: AuthorizationSubject,
): string {
  return JSON.stringify({
    userId: subject.userId,
    roles: [...subject.roles].sort(),
    permissions: [...subject.permissions].sort(),
    locationIds: [...subject.locationIds].sort(),
  });
}
